import { NOMINATION_STATUS } from './constants';

export const filteringTableGetButtonToolTipText = (
  nominationStatusTypeId,
  candidate = '',
) =>
  nominationStatusTypeId === NOMINATION_STATUS.DRAFT
    ? `Edit ${candidate}`
    : `View ${candidate}`;
